import { helpCharm_ariaLabel } from 'owa-locstrings/lib/strings/helpcharm_arialabel.locstring.json';
import loc from 'owa-localize';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';

import * as React from 'react';
import { sendMiniMavenDataPoint, destroyWidgetOnPaneDismiss } from 'owa-help-charm';
import MiniMavenPane from './MiniMavenPane';

export default observer(function HelpPane({ onDismiss }: HeaderPaneProps) {
    const isMiniMavenWidgetEnabled: boolean = isFeatureEnabled('help-miniMavenWidget');
    React.useEffect(() => {
        if (isMiniMavenWidgetEnabled) {
            sendMiniMavenDataPoint({
                sessionId: '',
                eventId: 'HelpPaneRendered',
                eventData: 'Owa Mail',
                loadTime: '',
                isDeeplinkScenario: '',
            });
        }

        return () => {
            if (isMiniMavenWidgetEnabled) {
                destroyWidgetOnPaneDismiss();
            }
        };
    }, [isMiniMavenWidgetEnabled]);

    return (
        <HeaderFlexPane
            title={loc(helpCharm_ariaLabel)}
            content={<MiniMavenPane onDismiss={onDismiss} />}
            onDismiss={onDismiss}
        />
    );
});
